import { ReactNode } from 'react';
import { AuthProvider } from './contexts/auth';
import { PropertyProvider } from './contexts/property';
import { ScrollProvider } from './contexts/scroll';
import { InterProvider } from './contexts/internationalization';
import { GlobalProvider } from './contexts/global';
import { HuntProvider } from './contexts/hunt';
import { BusinessProvider } from './contexts/business';
import { ChatProvider } from './contexts/chat';

export default function AppProviders({ children }: { children: ReactNode }) {
  return (
    <InterProvider>
      <AuthProvider>
        <BusinessProvider>
          <HuntProvider>
            <GlobalProvider>
              <PropertyProvider>
                <ScrollProvider>
                  <ChatProvider>{children}</ChatProvider>
                </ScrollProvider>
              </PropertyProvider>
            </GlobalProvider>
          </HuntProvider>
        </BusinessProvider>
      </AuthProvider>
    </InterProvider>
  );
}
